export const PAGES = {
  LOGIN: 'login',
  SIGN_UP: 'signup',
  RESEND: 'resend',
  FORGOT_PASSWORD: 'forgot-password',
  CHANGE_PASSWORD: 'change-password'
};
